const CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

let loading: Promise<boolean> | null = null;

// Loads Razorpay's checkout.js once, on first use — no point shipping it to
// every page. Resolves false if it can't be loaded (offline, blocked).
export const loadRazorpayCheckout = (): Promise<boolean> => {
  if ((window as any).Razorpay) return Promise.resolve(true);
  if (loading) return loading;
  loading = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = CHECKOUT_SRC;
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => {
      loading = null;
      resolve(false);
    };
    document.body.appendChild(script);
  });
  return loading;
};
